import styles from "./Markdown.module.css";
import { Box, Code, ScrollArea, Table } from "@mantine/core";
import type { ReactNode } from "react";
import type { Components } from "react-markdown";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const markdownComponents = {
  // Markdown content is typically LLM-generated with external citations; keep the page open behind them.
  a: ({ href, children }: { href?: string; children?: ReactNode }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
  code: ({ children }: { children?: ReactNode }) => <Code>{children}</Code>,
  table: ({ children }: { children?: ReactNode }) => (
    <ScrollArea type="auto" my="xs">
      <Table withTableBorder withColumnBorders>
        {children}
      </Table>
    </ScrollArea>
  ),
  thead: ({ children }: { children?: ReactNode }) => <Table.Thead>{children}</Table.Thead>,
  tbody: ({ children }: { children?: ReactNode }) => <Table.Tbody>{children}</Table.Tbody>,
  tr: ({ children }: { children?: ReactNode }) => <Table.Tr>{children}</Table.Tr>,
  th: ({ children }: { children?: ReactNode }) => <Table.Th>{children}</Table.Th>,
  td: ({ children }: { children?: ReactNode }) => <Table.Td>{children}</Table.Td>
};

export default function Markdown({ children, components = {} }: { children: string; components?: Components }) {
  return (
    <Box className={styles.markdown}>
      {/* singleTilde: false — remark-gfm v4 defaults to true, which treats ~text~ as strikethrough.
          LLM-generated content uses single tildes for scientific notation etc., not markdown. */}
      <ReactMarkdown
        remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
        components={{ ...markdownComponents, ...components }}
      >
        {children}
      </ReactMarkdown>
    </Box>
  );
}
